function removeEm(input) {
  //   console.log("removeEm - input: " + input);
  let step1 = input.replaceAll("<em>", "");
  let output = step1.replaceAll("</em>", "");
  //   console.log("removeEm - output: " + output);
  return output;
}

function replaceEm(input, emlessText, emphasizedText) {
  let output = input.replace(emlessText, emphasizedText);
  return output;
}

export { removeEm, replaceEm };
